<template>
  <com-header :actived="3"></com-header>
  <div class="operation-container inner-container">
    <inner-banner
      :img="bannerImg"
      title="近20年技术沉淀，积极应对行业痛点赋予您迎接挑战和机遇的新能力"
      brief="为合作伙伴提供直播、电商、政务民生等领域内的解决方案，帮助合作伙伴创建更具有竞争力的应用及服务。"
      link="联系我们"
    ></inner-banner>
    <div class="common-container pt-10">
       <tab-nav :navs="data.navs" :active="actived" @change="changeNav"></tab-nav>
       <div class="tab-panel">
         <div class="tab-item" v-if="actived === 0">
           <photo-box></photo-box>
         </div>
         <div class="tab-item" v-if="actived === 1">
           <policy-view></policy-view>
         </div>
         <div class="tab-item" v-if="actived === 2">
           <activity-view></activity-view>
         </div>
         <div class="tab-item" v-if="actived === 3">
           <big-screen></big-screen>
         </div>
         <div class="tab-item" v-if="actived === 4">
           <app-view></app-view>
         </div>
         <div class="tab-item" v-if="actived === 5">
           <applet-view></applet-view>
         </div>
         <div class="tab-item" v-if="actived === 6">
           <case-view></case-view>
         </div>
         <div class="tab-item" v-if="actived === 7">
           <live-view></live-view>
         </div>
       </div>
    </div>
  </div>
  <com-footer></com-footer>
</template>
<script setup>
import bannerImg from '@/assets/images/operation/operation-banner.png';
import PhotoBox from './common/PhotoBox.vue';
import BigScreen from './common/bigScreen.vue';
import SubjectBox from './common/SubjectBox.vue';
import appView from './common/appView.vue';
import policyView from './common/policyView.vue';
import liveView from './common/liveView.vue';
import appletView from './common/appletView.vue';
import activityView from './common/activityView.vue';
import caseView from './common/caseView.vue';




import { reactive, ref } from 'vue'
const data  = reactive({
  navs:['运营活动','政策图解','专题定制','大屏定制','APP定制','小程序定制','方案定制','直播']
})
const actived  = ref(0)
const changeNav  = (index)=>{
  actived.value = index
}
</script>
<style >
@import url('./../assets/style/inner.less');
</style>